export default __webpack_public_path__ + "static/media/basketball-img.b1249c73.png";